// extracted by mini-css-extract-plugin
export default {"TextCell":"interactive-item-title-module__TextCell--b2FiX","Link":"interactive-item-title-module__Link--x7M5B","is-disabled":"interactive-item-title-module__is-disabled--jM0Fx"};